export default __webpack_public_path__ + "static/media/m_engineering_card18_1.39d50e09.png";